// extracted by mini-css-extract-plugin
export default {"svgIconDefault":"style_svgIconDefault__t2P5e"};